import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Col, Row, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from 'src/shared/components/form/Select';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import LabelIcon from '@mui/icons-material/Label';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import SaveIcon from '@mui/icons-material/Save';

const required = value => value ? undefined : 'Required'

const renderCompactField = ({ input, placeholder, type, meta: { touched, error, warning }, disabled, icon: Icon }) => (
  <div>
    <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
      {Icon && (
        <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
          <Icon style={{ fontSize: '1rem' }} />
        </span>
      )}
      <input
        {...input}
        className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        style={{ fontSize: '0.85rem' }}
      />
      {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
    </div>
  </div>
);

const AddOrUpdateTagDetails = ({ handleSubmit, data }) => {
  const [isDlvTag, setDlvTag] = useState([]);

  useEffect(() => {
    getCustomerDeliveryTags();
  }, []);

  const getCustomerDeliveryTags = async () => {
    try {
      const response = await PndRestApi.GetCustomerDeliveryTags();
      if (response.status === 200 && response.data.status === 200) {
        let list = response.data.data.map(item => ({
          label: item.tagName,
          value: item.tagId
        }));
        setDlvTag(list);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <form className="p-1" onSubmit={handleSubmit}>
      <Card className="border-0 shadow-sm mb-3">
        <CardBody className="p-3">
          <div className="d-flex align-items-center mb-3 text-primary border-bottom pb-2">
            <LabelIcon style={{ fontSize: '1.2rem' }} className="me-2" />
            <h6 className="m-0 fw-bold small text-uppercase">Mapping Details</h6>
          </div>

          <Row className="g-3">
            <Col md={6}>
              <div className="mb-1">
                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                  Customer ID <span className='text-danger'>*</span>
                </label>
                <Field
                  name="customerId"
                  component={renderCompactField}
                  type="text"
                  placeholder="Enter Customer ID"
                  validate={[required]}
                  icon={PersonIcon}
                />
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-1">
                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                  Delivery Tag <span className='text-danger'>*</span>
                </label>
                <Field
                  validate={[required]}
                  name="tagId"
                  component={renderSelectField}
                  options={isDlvTag}
                  placeholder="Select Tag..."
                  menuPortalTarget={document.body}
                />
              </div>
            </Col>

            <Col md={12}>
              <div className="mb-1">
                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                  Tag Description / Remarks
                </label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                    <DescriptionIcon style={{ fontSize: '1rem' }} />
                  </span>
                  <Field
                    name="remarks"
                    component="textarea"
                    className="form-control form-control-sm border-start-0"
                    placeholder="Enter additional details..."
                    style={{ fontSize: '0.85rem', minHeight: '80px' }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="d-flex justify-content-end pt-2 mt-2 border-top">
        <Button
          color="primary"
          type="submit"
          size="sm"
          className="px-4 py-2 rounded-pill shadow-sm d-flex align-items-center"
          style={{
            background: 'linear-gradient(90deg, #6b8cce 0%, #526fbf 100%)',
            border: 'none',
            fontWeight: 'bold',
            fontSize: '0.85rem'
          }}
        >
          <SaveIcon style={{ fontSize: '1rem' }} className="me-2" />
          {data ? 'Update Mapping' : 'Save Mapping'}
        </Button>
      </div>
    </form>
  );
};

AddOrUpdateTagDetails.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  data: PropTypes.object
};

const mapStateToProps = (state, data) => {
  if (data && data?.data) {
    return {
      initialValues: {
        custTagMapId: data?.data?.custTagMapId,
        tagId: { value: data?.data?.tagId, label: data?.data?.tagName },
        remarks: data?.data?.remarks,
        customerId: data?.data?.customerId,
      }
    }
  }
}

export default connect(mapStateToProps)(reduxForm({ form: 'AddOrUpdateTagDetailsform', enableReinitialize: true })(AddOrUpdateTagDetails));